/* eslint-disable import/no-unresolved */
import React from "react";
import { bool, shape, string } from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { selectors as sessionSelectors } from "reducers/session";
import { selectors as configSelectors } from "reducers/config";

import { getLoginStep3Path, getPostLoginHomePath, getUnauthenticatedLoginPath } from "util/v3UxConfig";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

import PrivateLayout from "v3/layout/PrivateLayout";
import DashboardV3 from "v3/pages/dashboard/DashboardV3";

/**
 * Shell autenticado v3: layout privado + home Dashboard.
 * Dashboard flag off → legacy `/desktop` (not `/v3/dashboard`, avoids redirect loop).
 * No session → login per `frontend.UXImprovements.Login.functionalities`.
 * Session but no environment → step 3 for the active login shell.
 */
function V3PrivateDashboardRoute({
    hasActiveSession,
    activeEnvironment,
    uxDashboardImprovements,
    uxLoginImprovements,
    location,
}) {
    const loginPath = getUnauthenticatedLoginPath(uxLoginImprovements);

    if (!hasActiveSession) {
        return <Redirect to={loginPath} />;
    }
    if (!uxDashboardImprovements) {
        return <Redirect to={getPostLoginHomePath(false)} />;
    }
    if (!activeEnvironment) {
        return <Redirect to={getLoginStep3Path(uxLoginImprovements)} />;
    }

    return (
        <PrivateLayout>
            <DashboardV3 location={location} />
        </PrivateLayout>
    );
}

V3PrivateDashboardRoute.propTypes = {
    hasActiveSession: bool.isRequired,
    activeEnvironment: shape({}),
    uxDashboardImprovements: bool.isRequired,
    uxLoginImprovements: bool.isRequired,
    location: shape({
        pathname: string.isRequired,
        search: string,
        hash: string,
    }),
};

V3PrivateDashboardRoute.defaultProps = {
    activeEnvironment: null,
    location: undefined,
};

const mapStateToProps = (state) => ({
    hasActiveSession: sessionSelectors.isLoggedIn(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    uxDashboardImprovements: isUxDashboardImprovementsEnabled(),
    uxLoginImprovements: !!configSelectors.getConfigKey(state, "frontend.UXImprovements.Login.functionalities"),
});

export default connect(mapStateToProps)(V3PrivateDashboardRoute);
